import { render, staticRenderFns } from "./PaymentCompleteRecipientInfo.vue?vue&type=template&id=9ea871da&scoped=true&"
import script from "./PaymentCompleteRecipientInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentCompleteRecipientInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCompleteRecipientInfo.vue?vue&type=style&index=0&id=9ea871da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea871da",
  null
  
)

export default component.exports